import { TaskState } from '@Common/types/bo/tasks';

import { TranslationKeys } from '@I18n/types';

export const taskStateChoices: { id: TaskState; name: TranslationKeys }[] = [
  { id: 'PENDING', name: 'resources.tasks.states.PENDING' },
  { id: 'AWAITING_CUSTOMER', name: 'resources.tasks.states.AWAITING_CUSTOMER' },
  { id: 'RESOLVED', name: 'resources.tasks.states.RESOLVED' },
  { id: 'REJECTED', name: 'resources.tasks.states.REJECTED' },
];
